let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("inCHL")).then(() => parcelRequire('8KrTk'));